// eslint-disable-next-line no-unused-vars
import React from 'react'
import RecoveryBox from './RecoveryBox'
import ConfirmationBoxWithFiles from './ConfirmationBoxWithFiles'
import SendDocumentsBox from './SendDocumentsBox'
import ResendBox from './ResendBox'
import ConfirmationBox from './ConfirmationBox'
import ResendBoxSms from './ResendBoxSms'
import ErrorConsultOnboardingBox from './ErrorConsultOnboardingBox'
import RecoveryBoxSms from './RecoveryBoxSms'
import ExistsOnboardingBox from './ExistsOnboardingBox'
import ExistsApprovedOnboardingBox from './ExistsApprovedOnboardingBox'
import LoadingBox from './LoadingBox'

import Helmet from 'react-helmet'
const RecoveryForm = (props) => (
  <form method='post'>
    {props.isConfirmationWithFiles ? (
      <ConfirmationBoxWithFiles {...props} />
    ) : props.isConfirmation ? (
      <ConfirmationBox {...props} />
    ) : props.isSendDocument ? (
      <SendDocumentsBox {...props} />
    ) : props.isResendSMS ? (
      <ResendBoxSms {...props} />
    ) : props.isSendSMS ? (
      <RecoveryBoxSms {...props} />
    ) : props.isResend ? (
      <ResendBox {...props} />
    ) : props.isExistsOnboardingBox ? (
      <ExistsOnboardingBox {...props} />
    ) : props.isApprovedOnboarding ? (
      <ExistsApprovedOnboardingBox {...props} />
    ) : props.isSendEmail ? (
      <>
        <Helmet>
          <title>{`${process.env.RAZZLE_TITLE} - Recuperar acesso`}</title>
        </Helmet>
        <RecoveryBox {...props} />
      </>
    ) : props.isError ? (
      <ErrorConsultOnboardingBox {...props} />
    ) : (
      <>
        <Helmet>
          <title>{`${process.env.RAZZLE_TITLE} - Carregando...`}</title>
        </Helmet>
        <LoadingBox {...props} />
      </>
    )}
  </form>
)

export default RecoveryForm
